import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import redEg from "../assets/images/redEg.png";
import blueEg from "../assets/images/blueEg.png";
import blueGreenEg from "../assets/images/blueGreenEg.png";
import yellowEg from "../assets/images/yellowEg.png";
import greenEg from "../assets/images/greenEg.png";
import purpleEg from "../assets/images/purpleEg.png";
import jrRedEg from "../assets/images/jrRedEg.png";
import rcBlueEg from "../assets/images/rcBlueEg.png";
import raspYellowEg from "../assets/images/raspYellowEg.png";
import cloudsBg from "../assets/images/clouds-bg.png";
import ProductNavbar from "../components/ProductNavbar";
import Fillings from "../components/Fillings";
import Ingredients from "../components/Ingredients";
import clouds from "../assets/images/clouds-bg.png";



export default function Products() {
  const [maskRed, setMaskRed] = useState(0);
  const [maskBlue, setMaskBlue] = useState(0);
  const [maskBlueGreen, setMaskBlueGreen] = useState(0);
  const [maskYellow, setMaskYellow] = useState(0);
  const [maskGreen, setMaskGreen] = useState(0);
  const [maskPurple, setMaskPurple] = useState(0);
  const [maskjrRed, setMaskjrRed] = useState(0);
  const [maskrcBlue, setMaskrcBlue] = useState(0);
  const [maskraspYellow, setMaskraspYellow] = useState(0);
  const location = useLocation();

   useEffect(() => {
    if (location.hash) {
      // stop browser default jump
      setTimeout(() => {
        const id = location.hash.replace("#", "");
        const el = document.getElementById(id);
        if (el) {
          const y = el.getBoundingClientRect().top + window.pageYOffset;
          window.scrollTo({ top: y, behavior: "instant" }); // no animation for first load
        }
      }, 0);
    }
  }, [location]);


  useEffect(() => {
    const handleScroll = () => {
      const redSection = document.querySelector(".red-panel");
      const blueSection = document.querySelector(".blue-panel");
      const blueGreenSection = document.querySelector(".blueGreen-panel");
      const yellowSection = document.querySelector(".yellow-panel");
      const greenSection = document.querySelector(".green-panel");
      const purpleSection = document.querySelector(".purple-panel");
      const jrRedSection = document.querySelector(".dark-red-panel");
      const rcBlueSection = document.querySelector(".baby-blue-panel");
      const raspYellowSection = document.querySelector(".dark-yellow-panel");
      const windowHeight = window.innerHeight;

      // Blue reveals over Red
      if (blueSection) {
        const rect = blueSection.getBoundingClientRect();
        const progress = Math.min(
          Math.max((windowHeight - rect.top) / windowHeight, 0),
          1
        );
        setMaskRed(progress * 100);
      }

      // BlueGreen reveals over Blue
      if (blueGreenSection) {
        const rect = blueGreenSection.getBoundingClientRect();
        const progress = Math.min(
          Math.max((windowHeight - rect.top) / windowHeight, 0),
          1
        );
        setMaskBlue(progress * 100);
      }

      // Yellow reveals over BlueGreen
      if (yellowSection) {
        const rect = yellowSection.getBoundingClientRect();
        const progress = Math.min(
          Math.max((windowHeight - rect.top) / windowHeight, 0),
          1
        );
        setMaskBlueGreen(progress * 100);
      }
      // Green reveals over Yellow
      if (greenSection) {
        const rect = greenSection.getBoundingClientRect();
        const progress = Math.min(
          Math.max((windowHeight - rect.top) / windowHeight, 0),
          1
        );
        setMaskYellow(progress * 100);
      }
      // Purple reveals over Green
      if (purpleSection) {
        const rect = purpleSection.getBoundingClientRect();
        const progress = Math.min(
          Math.max((windowHeight - rect.top) / windowHeight, 0),
          1
        );
        setMaskGreen(progress * 100);
      }
      // DarkRed reveals over Purple
      if (jrRedSection) {
        const rect = jrRedSection.getBoundingClientRect();
        const progress = Math.min(
          Math.max((windowHeight - rect.top) / windowHeight, 0),
          1
        );
        setMaskPurple(progress * 100);
      }
      // BabyBlue reveals over DarkRed
      if (rcBlueSection) {
        const rect = rcBlueSection.getBoundingClientRect();
        const progress = Math.min(
          Math.max((windowHeight - rect.top) / windowHeight, 0),
          1
        );
        setMaskjrRed(progress * 100);
      }
      // DarkYellow reveals over BabyBlue
      if (raspYellowSection) {
        const rect = raspYellowSection.getBoundingClientRect();
        const progress = Math.min(
          Math.max((windowHeight - rect.top) / windowHeight, 0),
          1
        );
        setMaskrcBlue(progress * 100);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
  <div
    className="products-page"
    style={{
      display: "flex",
      flexDirection: "column",
      position: "relative",
      alignContent: "flex-start",
    }}
  >
      <ProductNavbar />

      {/* Shared background style */}
      {(() => {
        var cloudStyle = {
          backgroundImage: `url('/assets/clouds.png')`, // <-- put your correct path here
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        };
        return (
        <>
          
        {/* Panels */}
        {/* Begining of STrawberry Panel */}
        <div id="sr-anchor" style={{ position: "relative" }}></div>
        <div
          className="red-panel"
          style={{
            height: "100vh",
            background: "#e14d54",
            position: "relative",   // panel is the anchor for absolute children
            top: 0,
            overflow: "hidden",
          }}
        >
          {/* Clouds background */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${clouds})`,
              backgroundRepeat: "repeat-x",
              backgroundSize: "cover",
              animation: "scrollClouds 60s linear infinite",
              opacity: 0.2,
              zIndex: 0,
            }}
          />

          {/* Panel content directly inside panel */}
          <h2 className="panel-title" style={{ position: "relative", zIndex: 1 }}>
            STRAWBERRY RUNTZ
          </h2>

          <Fillings fillings={["Euphoric", "Happy", "Creative"]} />
          <Ingredients
            ingredients={["Honey", "Strawberry", "Apricot"]}
            strainInfo="Hybrid | 32% THC"
          />
        </div>
        {/* End of Strawberry Panel */}

        {/* Beginning of Zkittlez Panel */}
        <div id="zk-anchor" style={{ position: "relative" }}></div>
        <div
          className="blue-panel"
          style={{
            height: "100vh",
            background: "#05598e",
            position: "relative",   // anchor for children
            top: 0,
            overflow: "hidden",
          }}
        >
          {/* Clouds background */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${clouds})`,
              backgroundRepeat: "repeat-x",
              backgroundSize: "cover",
              animation: "scrollClouds 60s linear infinite",
              opacity: 0.4,
              zIndex: 0,
            }}
          />

          {/* Panel content */}
          <h2 className="panel-title" style={{ position: "relative", zIndex: 1 }}>
            ZKITTLEZ
          </h2>

          <Fillings fillings={["Relaxed", "Sleepy", "Hungry"]} />
          <Ingredients
            ingredients={["Honey", "Strawberry", "Apricot"]}
            strainInfo="Indica Hybrid | 20% THC"
          />
        </div>
        {/* End of Zkittlez Panel */}


        {/* Beginning of Blowpopz Panel */}
        <div id="bp-anchor" style={{ position: "relative" }}></div>
        <div
          className="blueGreen-panel"
          style={{
            height: "100vh",
            background: "#1a936f",
            position: "relative",   // anchor positioning
            top: 0,
            overflow: "hidden",
          }}
        >
          {/* Clouds background */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${clouds})`,
              backgroundRepeat: "repeat-x",
              backgroundSize: "cover",
              animation: "scrollClouds 60s linear infinite",
              opacity: 0.4,
              zIndex: 0,
            }}
          />

          {/* Panel content */}
          <h2 className="panel-title" style={{ position: "relative", zIndex: 1 }}>
            BLOWPOPZ
          </h2>

          <Fillings fillings={["Euphoric", "Happy", "Relaxed"]} />
          <Ingredients
            ingredients={["Honey", "Strawberry", "Apricot"]}
            strainInfo="70% Indica - 30% Sativa"
          />
        </div>
        {/* End of Blowpopz Panel */}

        {/* Beginning of LCG Panel */}
        <div id="lcg-anchor" style={{ position: "relative" }}></div>
        <div
          className="yellow-panel"
          style={{
            height: "100vh",
            background: "#dbbe53ff",
            position: "relative",
            top: 0,
            overflow: "hidden",
          }}
        >
          {/* Clouds background */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${clouds})`,
              backgroundRepeat: "repeat-x",
              backgroundSize: "cover",
              animation: "scrollClouds 60s linear infinite",
              opacity: 0.4,
              zIndex: 0,
            }}
          />

          {/* Panel content */}
          <h2 className="panel-title" style={{ position: "relative", zIndex: 1 }}>
            LEMON CHERRY GELATO
          </h2>

          <Fillings fillings={["Tingly", "Relaxed", "Giggly"]} />
          <Ingredients
            ingredients={["Honey", "Strawberry", "Apricot"]}
            strainInfo="Hybrid | 20% THC"
          />
        </div>
        {/* End of LCG Panel */}


      {/* Beginning of Apples Revenge Panel */}
      <div id="ar-anchor" style={{ position: "relative" }}></div>
      <div
        className="green-panel"
        style={{
          height: "100vh",
          background: "#6cb12d",
          position: "relative",
          top: 0,
          overflow: "hidden",
        }}
      >
        {/* Clouds background */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${clouds})`,
            backgroundRepeat: "repeat-x",
            backgroundSize: "cover",
            animation: "scrollClouds 60s linear infinite",
            opacity: 0.4,
            zIndex: 0,
          }}
        />

        {/* Panel content */}
        <h2 className="panel-title" style={{ position: "relative", zIndex: 1 }}>
          APPLES REVENGE
        </h2>

        <Fillings fillings={["Tingly", "Relaxed", "Giggly"]} />
        <Ingredients
          ingredients={["Honey", "Strawberry", "Apricot"]}
          strainInfo="50% Indica - 50% Sativa"
        />
      </div>
      {/* End of Apples Revenge Panel */}


        {/* Beginning of Starburst Panel */}
        <div id="sb-anchor" style={{ position: "relative" }}></div>
        <div
          className="purple-panel"
          style={{
            height: "100vh",
            background: "#645497",
            position: "relative",
            top: 0,
            overflow: "hidden",
          }}
        >
          {/* Clouds background */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${clouds})`,
              backgroundRepeat: "repeat-x",
              backgroundSize: "cover",
              animation: "scrollClouds 60s linear infinite",
              opacity: 0.4,
              zIndex: 0,
            }}
          />

          {/* Foreground content */}
          <h2 className="panel-title" style={{ position: "relative", zIndex: 1 }}>
            STARBURST
          </h2>
          <Fillings fillings={["Talkative", "Uplifted", "Happy"]} />
          <Ingredients
            ingredients={["Honey", "Strawberry", "Apricot"]}
            strainInfo="Ultra Potent Hybrid"
          />
        </div>
        {/* End of Starburst Panel */}

        {/* Beginning of Jelly Rancher Panel */}
        <div id="jr-anchor" style={{ position: "relative" }}></div>
        <div
          className="dark-red-panel"
          style={{
            height: "100vh",
            background: "#bf3b42ff",
            position: "relative",
            top: 0,
            overflow: "hidden",
          }}
        >
          {/* Clouds background */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${clouds})`,
              backgroundRepeat: "repeat-x",
              backgroundSize: "cover",
              animation: "scrollClouds 60s linear infinite",
              opacity: 0.4,
              zIndex: 0,
            }}
          />

          {/* Panel content */}
          <h2 className="panel-title" style={{ position: "relative", zIndex: 1 }}>
            JELLY RANCHER
          </h2>

          <Fillings fillings={["Happy", "Focused", "Relaxed"]} />
          <Ingredients
            ingredients={["Berry", "Citrus", "Apple"]}
            strainInfo="Sativa Dominant Hybrid | 20% THC"
          />
        </div>
        {/* End of Jelly Rancher Panel */}

        {/* Beginning of Rainbow Cookies Panel */}
        <div id="rc-anchor" style={{ position: "relative" }}></div>
        <div
          className="baby-blue-panel"
          style={{
            height: "100vh",
            background: "#044e7bff",
            position: "relative",
            top: 0,
            overflow: "hidden",
          }}
        >
          {/* Clouds background */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${clouds})`,
              backgroundRepeat: "repeat-x",
              backgroundSize: "cover",
              animation: "scrollClouds 60s linear infinite",
              opacity: 0.4,
              zIndex: 0,
            }}
          />

          {/* Panel content */}
          <h2 className="panel-title" style={{ position: "relative", zIndex: 1 }}>
            RAINBOW COOKIES
          </h2>

          <Fillings fillings={["Relaxed", "Giggly", "Euphoric"]} />
          <Ingredients
            ingredients={["Tropical", "Treefruit", "Sweet"]}
            strainInfo="Indica Strain | 20% THC"
          />
        </div>
        {/* End of Rainbow Cookies Panel */}

        {/* Beginning of Raspberry Cheesecake Panel */}
        <div id="rch-anchor" style={{ position: "relative" }}></div>
        <div
          className="dark-yellow-panel"
          style={{
            height: "100vh",
            background: "#dcb732ff",
            position: "relative",
            top: 0,
            overflow: "hidden",
          }}
        >
          {/* Clouds background */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundImage: `url(${clouds})`,
              backgroundRepeat: "repeat-x",
              backgroundSize: "cover",
              animation: "scrollClouds 60s linear infinite",
              opacity: 0.4,
              zIndex: 0,
            }}
          />

          {/* Panel content */}
          <h2 className="panel-title" style={{ position: "relative", zIndex: 1 }}>
            RASPBERRY CHEESECAKE
          </h2>

          <Fillings fillings={["Relaxed", "Sleepy", "Happy"]} />
          <Ingredients
            ingredients={["Cheese", "Strawberry", "Butter"]}
            strainInfo="Indica Dominant | 27% THC"
          />
        </div>
        {/* End of Raspberry Cheesecake Panel */}

          </>
        );
      })()}

        {/* PRODUCT STACK */}
        <div
          className="product-stack"
        >
          <div className="clip-layer" style={{ "--clip-top": "0%", "--clip-bottom": "1.2%", "--clip-right": "1.5%"}}>
            {/* Dark Yellow */}
            <img
              src={raspYellowEg}
              alt="Raspberry Cheesecake Product"
              style={{
                position: "absolute",
                width: "101.5%",
                height: "100%",
                objectFit: "cover",
                WebkitMaskImage: `linear-gradient(to bottom, transparent ${maskraspYellow}%, black ${maskraspYellow}%)`,
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskSize: "100% 100%",
                maskImage: `linear-gradient(to top, transparent ${maskraspYellow}%, black ${maskraspYellow}%)`,
                maskRepeat: "no-repeat",
                maskSize: "100% 100%",
                zIndex: 3,
              }}
            />

            {/* Baby Blue */}
            <img
              src={rcBlueEg}
              alt="Rainbow Candy Product"
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                WebkitMaskImage: `linear-gradient(to bottom, transparent ${maskrcBlue}%, black ${maskrcBlue}%)`,
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskSize: "100% 100%",
                maskImage: `linear-gradient(to top, transparent ${maskrcBlue}%, black ${maskrcBlue}%)`,
                maskRepeat: "no-repeat",
                maskSize: "100% 100%",
                zIndex: 4,
              }}
            />

            {/* Dark Red */}
            <img
              src={jrRedEg}
              alt="Jelly Rancher Product"
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                WebkitMaskImage: `linear-gradient(to bottom, transparent ${maskjrRed}%, black ${maskjrRed}%)`,
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskSize: "99.7% 99.2%",
                maskImage: `linear-gradient(to top, transparent ${maskjrRed}%, black ${maskjrRed}%)`,
                maskRepeat: "no-repeat",
                maskSize: "100% 100%",
                zIndex: 5,
              }}
            />

            {/* Purple */}
            <img
              src={purpleEg}
              alt="Starburst Product"
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                WebkitMaskImage: `linear-gradient(to bottom, transparent ${maskPurple}%, black ${maskPurple}%)`,
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskSize: "100% 100%",
                maskImage: `linear-gradient(to top, transparent ${maskPurple}%, black ${maskPurple}%)`,
                maskRepeat: "no-repeat",
                maskSize: "100% 100%",
                zIndex: 6,
              }}
            />

            {/* Green */}
            <img
              src={greenEg}
              alt="Apples Revenge Product"
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                WebkitMaskImage: `linear-gradient(to bottom, transparent ${maskGreen}%, black ${maskGreen}%)`,
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskSize: "100% 100%",
                maskImage: `linear-gradient(to top, transparent ${maskGreen}%, black ${maskGreen}%)`,
                maskRepeat: "no-repeat",
                maskSize: "100% 100%",
                zIndex: 7,
              }}
            />

            {/* Yellow */}
            <img
              src={yellowEg}
              alt="Lemon Cherry Gelato Product"
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                WebkitMaskImage: `linear-gradient(to bottom, transparent ${maskYellow}%, black ${maskYellow}%)`,
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskSize: "99% 98.5%",
                maskImage: `linear-gradient(to top, transparent ${maskYellow}%, black ${maskYellow}%)`,
                maskRepeat: "no-repeat",
                maskSize: "100% 100%",
                zIndex: 8,
              }}
            />

            {/* BlueGreen */}
            <img
              src={blueGreenEg}
              alt="Blowpopz Product"
              style={{
                position: "absolute",
                width: "100%",
                height: "99%",
                objectFit: "cover",
                WebkitMaskImage: `linear-gradient(to bottom, transparent ${maskBlueGreen}%, black ${maskBlueGreen}%)`,
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskSize: "100% 99.1%",
                maskImage: `linear-gradient(to top, transparent ${maskBlueGreen}%, black ${maskBlueGreen}%)`,
                maskRepeat: "no-repeat",
                maskSize: "100% 100%",
                zIndex: 9,
              }}
            />

            {/* Blue */}
            <img
              src={blueEg}
              alt="Zkittlez Product"
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                WebkitMaskImage: `linear-gradient(to bottom, transparent ${maskBlue}%, black ${maskBlue}%)`,
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskSize: "100% 100%",
                maskImage: `linear-gradient(to top, transparent ${maskBlue}%, black ${maskBlue}%)`,
                maskRepeat: "no-repeat",
                maskSize: "100% 100%",
                zIndex: 10,
              }}
            />

            {/* Red */}
            <img
              src={redEg}
              alt="Red Product"
              style={{
                position: "absolute",
                width: "100%",
                height: "100%",
                objectFit: "cover",
                WebkitMaskImage: `linear-gradient(to bottom, transparent ${maskRed}%, black ${maskRed}%)`,
                WebkitMaskRepeat: "no-repeat",
                WebkitMaskSize: "100% 100%",
                maskImage: `linear-gradient(to top, transparent ${maskRed}%, black ${maskRed}%)`,
                maskRepeat: "no-repeat",
                maskSize: "100% 100%",
                zIndex: 11,
              }}
            />
          </div>
        </div>

    </div>
  );
}
